module.exports = __webpack_public_path__ + "img/boatSea.17388ea5.jpg";